import React from 'react';
import RoomImageSlider from '../RoomImageSlider';

const RoomDetails = ({ roomDetails }) => {
  return (
    <div className="col-lg-8">             
      
      {/* <img
        src={`https://admin.abhyaranyan.com/RoomsUploadimage/${roomDetails.roomImage}`}
        alt={roomDetails.roomType}
        style={{ width: '100%', height: '400px', objectFit: 'cover' }}
        className="mb-4"
      /> */}
      <RoomImageSlider imageJson={roomDetails.imageJson} />
    </div>
  );
};

export default RoomDetails;
